import localforage from 'localforage'

// localforage.setDriver(localforage.INDEXEDDB)
// localforage.setDriver(localforage.LOCALSTORAGE);
localforage.config({
  driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB],
  name: 'officemail-web-access',
  // storeName: 'zero-dark-web',
})

const infoDB = localforage.createInstance({
  name: 'officemail-web-access-db',
})
infoDB.setDriver(localforage.INDEXEDDB)

export { infoDB }

export default localforage
